import { ArrowRight, ArrowUpRight } from 'lucide-react'

import Button from '/react4xp/components/prototype/Button'
import Card from '/react4xp/components/prototype/Card'

import type { CardSelectionProps } from './types'

export default function CardSelection({
	overline,
	title,
	intro,
	cta,
	cards = [],
}: CardSelectionProps) {
	// The cards keep an empty label line so their titles align; with no category anywhere in the
	// row that line is only a gap, so drop it.
	const hasCategory = cards.some((card) => card.category)

	return (
		<section className="my-16 container">

			<div className="grid grid-cols-1 gap-y-6 xl:grid-cols-2 xl:gap-x-0">
				<div className="flex flex-col gap-3">
					{overline && <p className="body text-black-950">{overline}</p>}
					{title && <h2 className="h2 text-black-950">{title}</h2>}
				</div>

				<div className="flex flex-col items-start gap-6 xl:pl-3">
					{intro && <p className="body-xl text-black-950">{intro}</p>}
					{cta && (
						<Button variant="primary" size="lg" href={cta.url} isExternal={cta.isExternal}>
							{cta.label}
							{cta.isExternal ? (
								<ArrowUpRight className="h-[1lh] w-5 shrink-0" aria-hidden="true" />
							) : (
								<ArrowRight className="h-[1lh] w-5 shrink-0" aria-hidden="true" />
							)}
						</Button>
					)}
				</div>
			</div>

			{cards.length > 0 && (
				<div className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-2 xl:grid-cols-4">
					{cards.map((card, i) => (
						<Card
							key={i}
							image={card.image}
							label={card.category}
							title={card.title}
							url={card.url}
							isExternal={card.isExternal}
							titleSize="h3"
							variant="article"
							reserveLabelSpace={hasCategory}
						/>
					))}
				</div>
			)}

		</section>
	)
}
